import { TextField } from "@mui/material";
import { TypeCommon } from "models/common";
import { forwardRef, ReactElement } from "react";
import "./index.css";

type BaseInputMuiProps = {
  label?: string;
  value?: string;
  onChange?: (event: TypeCommon) => void;
  type?: string;
  placeholder?: string;
  fullWidth?: boolean;
  required?: boolean;
  rows?: number;
  multiline?: boolean;
  margin?: TypeCommon;
  error?: boolean;
  style?: TypeCommon;
  sx?: TypeCommon;
  inputProps?: TypeCommon;
  disabled?: boolean;
  className?: string;
  helperText?: string;
  onBlur?: TypeCommon;
  onKeyDown?: TypeCommon;
};

// 👇 Sử dụng forwardRef để truyền ref đúng
const BaseInputMui = forwardRef<HTMLInputElement, BaseInputMuiProps>(
  (
    {
      label,
      value,
      onChange,
      type = "text",
      placeholder,
      fullWidth = true,
      required = false,
      rows,
      multiline = false,
      margin = "normal",
      error,
      style,
      sx,
      inputProps,
      disabled = false,
      className,
      helperText,
      onBlur,
      onKeyDown,
    },
    ref
  ): ReactElement => {
    return (
      <TextField
        label={label}
        value={value || ""}
        onChange={onChange}
        type={type}
        className={className}
        placeholder={placeholder}
        variant="outlined"
        fullWidth={fullWidth}
        margin={margin}
        required={required}
        rows={rows}
        multiline={multiline}
        error={error}
        style={style}
        sx={sx}
        inputProps={inputProps}
        disabled={disabled}
        inputRef={ref} // 👈 truyền ref cho TextField ở đây
        helperText={helperText}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
    );
  }
);

// 👇 Thêm display name để tránh lỗi ESLint
BaseInputMui.displayName = "BaseInputMui";

export default BaseInputMui;